<template>
  <div class="iframe-payment-summary tempus-iframe-800-container table-striped" id="paymentSummary" v-if="sale && Object.keys(sale).length">
    <template v-if="singleBooking">
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <h2 class="h1 heading my-3">Thank you for your purchase at<br>{{ location.brand }}!</h2>
            <h3 class="">
              A confirmation email has been sent immediately.
              <br>
              Please read it carefully!
            </h3>
            <h4 class="">
              <span class="font-weight-bold">
                Not received your email (sent to <span class="font-italic">{{ sale.customer.email }}</span>)?
                <br>
                Not in your spam folder?
              </span> -
              <a :href="location.locationContactHref">contact us</a>!
            </h4>
          </div>
        </div>
      </div>
      <div class="container py-3 bgDarker" style="border-top-left-radius: 35px; border-top-right-radius: 35px;">
        <div class="row my-2">
          <div class="col-3 text-right">
            <table style="float:right;">
              <tbody>
                <tr>
                  <td align="center" valign="top" class="bookingBlockMonth px-4">
                    {{ booking.room_slot.start | moment('MMM') }}
                  </td>
                </tr>
                <tr>
                  <td align="center" valign="top" class="bookingBlockDay">
                    {{ booking.room_slot.start | moment('D') }}
                  </td>
                </tr>
                <tr>
                  <td align="center" valign="top" class="bookingBlockDayname">
                    {{ booking.room_slot.start | moment('ddd') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-9 text-white">
            <h4 class="text-danger font-weight-bold">{{ booking.room_slot.room.name }} Booking Confirmed</h4>
            <h5 class="font-weight-bold">{{ booking.room_slot.start | moment('dddd[,] Do MMMM YYYY [@] h:mma') }}</h5>

            <h5 v-if="location.arrive_early">Please arrive {{ location.arrive_early }} minutes before your booked time ({{ arrivalTime | moment('h:mma') }}).</h5>
            <h5 v-else>Please arrive on time ({{ booking.room_slot.start | moment('h:mma') }}) for your booking (<span class="font-weight-bold">neither late nor early</span>).</h5>

            <h4 v-if="booking.room_slot.room.tour" class="">
              Booked for {{ booking.players }} {{ 'team' + (booking.players > 1 ? 's' : '') }}
            </h4>
            <h4 v-else-if="location.location_child_pricing" class="">
              Booked for {{ booking.adults }} {{ 'adult' + ((booking.adults > 1) ? 's' : '') }}<template v-if="booking.children"> and {{ (booking.children == 1) ? '1 child' : booking.children + ' children' }}</template>
            </h4>
            <h4 v-else class="">
              Booked for {{ booking.players }} {{ 'player' + ((booking.players > 1) ? 's' : '') }}
            </h4>
          </div>
        </div>
      </div>
      <div class="container-fluid py-4 room-info" :class="deploymentBgClass">
        <div class="container">
          <div class="row pt-2">
            <div class="col text-center">
              <h2 class="sect-title font-weight-bold">{{ booking.room_slot.room.name }}</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <img :src="'/img/mp/mp-' + booking.room_slot.room.nickname + '.jpg'" class="mb-2 pb-2 img-fluid" :alt="booking.room_slot.room.name + ' Movie Poster'">
            </div>
            <div class="col-sm-9">
              <h5 v-for="blurb in booking.room_slot.room.blurbs" v-html="blurb"></h5>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row text-center">
          <div class="col">
            <h2 class="heading my-3">CRITICAL INFORMATION</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="row">
              <div class="col-3 text-right">
                <img src="/img/booking/time.png" alt="Arrive on time" class="img-fluid" style="-webkit-filter: invert(1); filter: invert(1)">
              </div>
              <div class="col-9">
                <h3 class="heading" :class="$deploymentIn(['trappedinfiction','breakescape']) ? 'text-red' : 'text-pink'">Arrive on time</h3>
                <p>
                  Your game start is booked for {{ booking.room_slot.start | moment('h:mma') }}. In order to give us time to brief you and your team before your game, and to have the full {{ booking.room_slot.duration }} minutes to complete your experience, <template v-if="location.arrive_early"><b><i>please arrive at {{ arrivalTime | moment('h:mma') }}</i></b></template><template v-else><b><i>arrive on time at {{ booking.room_slot.start | moment('h:mma')}}</i></b></template>.
                </p>
                <p>If you arrive early, we cannot guarantee that we will have reset your room and the last thing we want is for you to bump into a group who spoils some of the game for you.</p>
                <p>If you arrive late, it's not fair to make groups after you wait so we will have to deduct time from your room.</p>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="row">
              <div class="col-3 text-right">
                <img src="/img/booking/locn.png" alt="Our location details" class="img-fluid" style="-webkit-filter: invert(1); filter: invert(1)">
              </div>
              <div class="col-9">
                <template v-if="$deploymentIn(['escapereading', 'escapable', 'housetrap', 'roomescapersboston'])">
                  <h3 class="heading text-pink">We Have Two Locations</h3>
                  <p>Your game is at this address:</p>
                  <p>{{ booking.room_slot.room.room_address }}</p>
                </template>
                <h3 class="heading" :class="$deploymentIn(['trappedinfiction','breakescape']) ? 'text-red' : 'text-pink'">
                  <a :href="location.locationFinsUsHref">Where</a> is {{ location.brand }}
                </h3>
                <p>Contact this branch <a :href="location.locationContactHref">HERE</a></p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="row">
              <div class="col-3 text-right">
                <img src="/img/booking/delay.png" alt="Are you expecting a delay?" class="img-fluid" style="-webkit-filter: invert(1); filter: invert(1)">
              </div>
              <div class="col-9">
                <h3 class="heading" :class="$deploymentIn(['trappedinfiction','breakescape']) ? 'text-red' : 'text-pink'">Expecting a delay?</h3>
                <p>Please keep us informed if you know you are running late. We will do what we can to get you the most from your experience, but if we are not kept in the loop then time will be deducted from your game. If you let us know before 48 hours of your booking, we will happily reschedule it for you.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template> <!-- singleBooking -->

    <template v-else-if="singleVoucher">
      <div class="container">
        <div class="row">
          <div class="col text-center pt-4">
            <h1 class="heading my-3">Thank you for your Gift Voucher purchase for {{ location.brand }}!</h1>
            <h3 class="text-secondary">A confirmation email has been sent immediately.</h3>
            <h4 class="">
              <span class="font-weight-bold">
                Not received your confirmation email (sent to <span class="font-italic" :class="$deploymentIs('trappedinfiction') ? 'text-dark-green' : 'text-tempus-blue-tint'">{{ voucher.customer.email }}</span>)?
                <br>
                Not in your spam folder?
              </span> -
              <a :href="location.locationContactHref" :class="$deploymentIs('trappedinfiction') ? 'text-dark-green' : 'text-tempus-blue-tint'">contact us</a>!
            </h4>
          </div>
        </div>
      </div>

      <div class="container py-3" :class="$deploymentIs('trappedinfiction') ? 'bg-trappedinfiction-dark text-white' : 'bg-tempus-blue-900'" style="border-top-left-radius: 35px; border-top-right-radius: 35px;">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h3 class="font-weight-bold" :class="$deploymentIn(['trappedinfiction','breakescape']) ? 'text-red' : 'text-pink'">Gift Voucher Purchased</h3>
            <h4 class="font-weight-bold">{{ voucher.description }} &mdash; {{ voucher.reference }}</h4>
            <hr>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <h5 class="heading">
                  <template v-if="voucherExpiry == 0">
                    No expiry
                  </template>
                  <template v-else-if="voucherExpiry == 12">
                    One Year Validity
                  </template>
                  <template v-else>
                    {{ voucherExpiry }} Month Validity
                  </template>
                </h5>
                <p v-if="voucherExpiry != 0">Gift Vouchers must be used within {{ voucherExpiry }} {{ voucherExpiry == 1 ? 'Month' : 'Months' }} of purchase.</p>
                <p v-else>Gift Vouchers have no expiration date, but don't forget about them!</p>

                <h5 class="heading">How To Redeem</h5>
                <p>Gift Vouchers can be redeemed via the booking system on our website.</p>
              </div>
              <div class="col-sm-12 col-md-6">
                <template v-if="voucherAutoEmail && voucher.send_by == 'E'">
                  <h5 class="heading">You Will Have Your Voucher Immediately</h5>
                  <p>Vouchers are processed by our systems immediately and will be emailed straight away (give up to a minute during busy periods). Please remember to check your spam folder.</p>
                </template>
                <template v-else>
                  <h5 class="heading">24-72 Hour Lead Time</h5>
                  <p v-if="voucher.send_by == 'E'">Electronic Vouchers will be processed and emailed within 24 hours.</p>
                  <p v-else-if="voucher.send_by == 'P'">
                    Mail vouchers will be placed in an envelope within 72 hours of purchase and be sent Royal Mail First Class to the address given at payment. Please <a :href="location.locationContactHref">contact us</a> if the voucher needs to be posted elsewhere.
                  </p>
                  <p v-else-if="voucher.send_by == 'I'">
                    Please come to the branch to collect your Gift Voucher.
                  </p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template> <!-- singleVoucher -->
    <template v-else-if="singleVirtualGame">
    </template>
    <template v-else>
      <div class="bg-tempus-blue-700 text-white">
        <div class="container">
          <div class="row">
            <div class="col text-center">
              <h1 class="heading my-3">Thank you for your purchase at {{ location.brand }}! <small v-if="$deploymentCurrent == 'cryptology' && location.slug == 'swindon'">t/a Incarcerated</small></h1>
              <h3 class="font-mon text-secondary">Confirmation emails have been sent immediately. Please read them carefully!</h3>
              <h4 class="font-mon"><span class="font-weight-bold">Not received your emails? Not in your spam folder?</span> - <a :href="location.locationContactHref">contact us</a>!</h4>
              <h4 class="font-mon text-pink font-weight-bold">Please <a :href="location.locationContactHref">get in touch</a> if you have any questions</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-tempus-blue-700 text-white tempus-iframe-form">
        <div class="container">
          <div class="row">
            <div class="col">
              <table class="table table-striped table-dark">
                <thead class="thead-dark">
                  <tr>
                    <th class="bg-tempus-blue">Item</th>
                    <th class="bg-tempus-blue">Details</th>
                    <th class="bg-tempus-blue">Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="saleItem in sale.sale_items">
                    <!--
                    @if (get_class($saleItem->saleable) == 'App\Models\Booking' && ! is_null(saleItem.saleable.roomSlot.room.mainRoom))
                    @continue
                    @endif
                    -->
                    <template v-if="saleItem.saleable_type == 'App\\Models\\Booking'">
                      <td style="vertical-align: middle;">
                        <div class="row">
                          <div class="col d-flex align-items-center justify-content-between">
                            <img :alt="saleItem.saleable.room_slot.room.name" :src="'/img/mp/mp-ls-' + saleItem.saleable.room_slot.room.nickname + '.jpg'" width="100" class="mr-2"/>
                            <p class="heading mb-0 flex-fill" :class="'text-' + saleItem.saleable.room_slot.room.nickname">{{ saleItem.saleable.room_slot.room.name }}</p>
                          </div>
                        </div>
                      </td>
                      <td class="flex-fill" style="vertical-align: middle;">
                        {{ saleItem.description }}
                      </td>
                      <td style="vertical-align: middle;">
                        {{ saleItem.sold_for | money }}
                      </td>
                    </template>
                    <template v-else-if="saleItem.saleable_type == 'App\\Models\\Voucher'">
                      <td style="vertical-align: middle;">
                        <img :src="location.mpVoucherLandscapeSrc" alt="Gift Voucher" width="100" class="mr-2">
                        <span class="heading text-cs-green">Gift Voucher</span>
                      </td>
                      <td style="vertical-align: middle;">
                        {{ saleItem.description }}
                      </td>
                      <td class="checkout-price" style="vertical-align: middle;">
                        {{ saleItem.sold_for | money }}
                      </td>
                    </template>
                    <template v-else-if="saleItem.saleable_type == 'App\\Models\\VirtualGame'">
                      <td style="vertical-align: middle;">
                        <div class="row">
                          <div class="col d-flex align-items-center justify-content-between">
                            <img :alt="saleItem.saleable.name" :src="'/img/mp/mp-ls-' + saleItem.saleable.nickname + '.jpg'" width="100" class="mr-2">
                            <p class="heading mb-0 flex-fill" :class="'text-' + saleItem.saleable.nickname">{{ saleItem.saleable.name }}</p>
                          </div>
                        </div>
                      </td>
                      <td style="vertical-align: middle;">
                        {{ saleItem.description }}
                      </td>
                      <td style="vertical-align: middle;">
                          {{ saleItem.sold_for | money }}
                      </td>
                    </template>
                    <template v-else-if="saleItem.saleable_type == 'App\\Models\\Product'">
                      <td style="vertical-align: middle;">
                        <div class="row">
                          <div class="col d-flex align-items-center justify-content-between">
                            <img
                              :alt="saleItem.saleable.name + ' representation'"
                              :src="saleItem.saleable.imageUrl ? saleItem.saleable.imageUrl : '/img/sale/product.jpg'"
                              width="100"
                              class="mr-2">
                            <p class="heading text-tempus-blue flex-fill mb-0">{{ saleItem.saleable.name }} <template v-if="saleItem.quantity > 1">&times;{{ saleItem.quantity }}</template></p>
                          </div>
                        </div>
                      </td>
                      <td style="vertical-align: middle;">
                        <p class="mb-0">{{ saleItem.saleable.saleDescription }} <template v-if="saleItem.quantity > 1"><span class="font-italic">({{ saleItem.quantity }} purchased)</span></template></p>
                        <p v-if="saleItem.options && saleItem.options.for_room_slot_id" class="mb-0 font-italic font-weight-bold">
                          <!-- For {{ App\Models\RoomSlot::find($saleItem->options['for_room_slot_id'])->quoteDescription }} -->
                          TBC
                        </p>
                      </td>
                      <td style="vertical-align: middle;">
                          {{ saleItem.sold_for | money }}
                      </td>
                    </template>
                  </tr>
                  <tr v-if="sale.sale_items.length == 0">
                    <td rowspan="3">For some reason there are no items in this Sale</td>
                  </tr>

                  <template v-if="sale.isDiscounted">
                    <tr v-for="discount in sale.discounts">
                      <td style="vertical-align: middle;">
                        <div class="row">
                          <div class="col">
                            <img alt="Discount" src="/img/sale/discount.jpg" width="100" class="mr-2">
                            <span class="heading">Discount:</span>
                          </div>
                        </div>
                      </td>
                      <td style="vertical-align: middle;">
                        {{ discount.description }} ({{ discount.style }})
                      </td>
                      <td class="text-red" style="vertical-align: middle;">
                        {{ -sale.discounted_amount | money }}
                      </td>
                    </tr>
                    <tr v-if="sale.discounts.length == 0">
                      <td style="vertical-align: middle;">
                        <div class="row">
                          <div class="col">
                            <img alt="Discount" src="/img/sale/discount.jpg" width="100" class="mr-2">
                            <span class="heading">Discount:</span>
                          </div>
                        </div>
                      </td>
                      <td style="vertical-align: middle;">
                        <template v-if="sale.discount_amount || sale.discount_percentage">{{ sale.discount_description }}</template>
                      </td>
                      <td class="text-red" style="vertical-align: middle;">
                        {{ -sale.discounted_amount | money }}
                      </td>
                    </tr>
                  </template>

                  <tr class="h5">
                    <td></td>
                    <td class="text-right font-weight-bold">TOTAL:</td>
                    <td class="font-weight-bold">{{ sale.total_amount | money }}</td>
                  </tr>
                  <tr v-if="sale.totalTransactionsAmount" class="h5 bg-tempus-blue text-white">
                    <td></td>
                    <td class="text-right font-weight-bold">PAID:</td>
                    <td class="font-weight-bold">{{ sale.totalTransactionsAmount | money }}</td>
                  </tr>
                  <tr v-if="sale.totalTransactionsAmount && sale.left_to_pay" class="h5">
                    <td></td>
                    <td class="text-right font-weight-bold">Remaining Balance:</td>
                    <td class="font-weight-bold">{{ sale.left_to_pay | money }}</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </template>

    <sale-survey
      v-if="saleSurveyEnabled && sale"
      :location="location"
      :sale="sale"
      :sale-survey-strings="saleSurveyStrings"></sale-survey>

    <div v-if="saleSurveyEnabled && sale && sale.saleSurvey" id="survey" class="container-fluid bg-tempus-blue-700">
      <div class="row">
        <div class="col">
          <h3 class="font-mon mt-2 mb-1 text-center font-weight-bold">Survey Completed - Thanks</h3>
          <br>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    voucherExpiry: {
      type: Number,
    },
    voucherAutoEmail: {
      type: Boolean,
      default: false,
    },
    saleSurveyStrings: {
      type: Object,
    },
    deploymentBgClass: {
      type: String,
    },
    saleSurveyEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      sale: null,
    };
  },

  computed: {
    singleSaleItem() {
      // what about Escapable with their Booking Fee?
      if (this.sale && this.sale.sale_items && this.sale.sale_items.length == 1) {
        return true;
      }
      return false;
    },

    singleBooking() {
      // what about Escapable with their Booking Fee?
      if (this.singleSaleItem && this.sale.sale_items[0].saleable_type == 'App\\Models\\Booking') {
        return true;
      }
      return false;
    },

    booking() {
      if (this.singleBooking) {
        return this.sale.sale_items[0].saleable;
      }
      return null;
    },

    arrivalTime() {
      if (this.booking && this.location.arrive_early) {
        return moment(this.booking.room_slot.start).add(-parseInt(this.location.arrive_early), 'm');
      }
      return null;
    },

    singleVoucher() {
      if (this.singleSaleItem && this.sale.sale_items[0].saleable_type == 'App\\Models\\Voucher') {
        return true;
      }
      return false;
    },

    voucher() {
      if (this.singleVoucher) {
        return this.sale.sale_items[0].saleable;
      }
      return null;
    },

    singleVirtualGame() {
      // TODO: iof we resurrect VirtualGames, then this will need completing
      return false;
    },
  },

  watch: {

  },

  methods: {
    saleRefreshed(sale) {
      if (this.consoleDebug) console.log('CheckoutPaymentSummary::saleRefreshed', sale);
      this.sale = sale;
    },
  },

  mounted() {

  },
}
</script>
